import gql from 'graphql-tag';

const userSubscriptionQuery = userId => gql`
  subscription DataSyncSubscription {
    dataSyncMutationSubscription(userId: "${userId}") {
      dataSyncId
      userId
      status
      message
    }
  }
`;

export default userSubscriptionQuery;
